//
//
//
//
//
//

import img404 from '../assets/404.png';

export default {

  data(){
    return {
      img404:img404
    }
  },
 }



// WEBPACK FOOTER //
// ./src/project/noFind.vue